import { Box, Typography, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";

export function Amount({ data }) {
  return (
    <BoxAmount>
      <img src={DefaultUrlWeb + data.coinImageUrl} width={"25px"} alt="" />

      <Typography variant="h6" pl={1} color="text.main">
        <NumberFormats value={data.amount} />
      </Typography>

      <Typography variant="subtitle1" pl={0.5} color="text.secondary">
        {data.coinName}
      </Typography>
    </BoxAmount>
  );
}

const BoxAmount = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
}));

export default Amount;
